export default __webpack_public_path__ + "static/media/VS-img.7a0bdedd.png";